export default __webpack_public_path__ + "static/img13-19168463bd50f8ecf391cfd1843d68c3.png";